__turbopack_context__.v({
  "className": "gamja_flower_ec2549e9-module__omFE8q__className",
});
